import React from 'react';
import { aboutData } from '../data/mock';

export const AboutSection = () => {
  return (
    <section id="about" className="py-32 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          {/* Profile Image */}
          <div className="flex-shrink-0">
            <div className="w-64 h-64 lg:w-80 lg:h-80 rounded-full overflow-hidden border-4 border-white shadow-xl">
              <img
                src="/navraj.jpeg"
                alt="Navraj Singh"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Content */}
          <div className="flex-1">
            {/* Section Title */}
            <h2 className="text-4xl sm:text-5xl font-extralight text-black mb-12 tracking-tight">
              {aboutData.title}
            </h2>

            {/* Paragraphs */}
            <div className="space-y-6">
              {aboutData.paragraphs.map((paragraph, index) => (
                <p
                  key={index}
                  className={`text-lg leading-relaxed ${
                    index === aboutData.paragraphs.length - 1
                      ? 'text-black font-medium text-xl'
                      : 'text-gray-600 font-light'
                  }`}
                >
                  {paragraph}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
